import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

import { BehaviorSubject } from "rxjs";
import { ToasterService, Toast, BodyOutputType } from 'angular2-toaster';

import { Model } from "../model/model";
import { Quote } from '../model/quote';

import { ToastrModelsComponent } from '../reusable-components/toastr-models';

import { ApplicationStateService } from "../services/application-state.service";
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { OptionsAdminService } from '../services/options-admin.service';
import { ModelService } from '../services/model.service';
import { QuoteInfoService } from "../services/quote-info.service";

@Injectable()
export class InformationAsideModelsService {
    showModelAside: BehaviorSubject<boolean> = new BehaviorSubject(false);
    informationModel: BehaviorSubject<Model> = new BehaviorSubject(null);
    toast: Toast;

    constructor(
        private applicationStateService: ApplicationStateService,
        private toasterService: ToasterService,
        private spinner: LoadingSpinnerService,
        private optionsAdminService: OptionsAdminService,
        private modelService: ModelService,
        private router: Router,
        private quoteInfoService: QuoteInfoService
    ) { }

    openModelInformation(information, event: Event) {
        event.stopPropagation();
        this.informationModel.next(information);
        this.showModelAside.next(true);
    }

    closeModelInformation() {
        this.showModelAside.next(false);
    }

    checkModels(model: Model) {
        this.spinner.showSpinner();
        this.applicationStateService.chosenModel = this.applicationStateService.chosenModel === undefined || this.applicationStateService.chosenModel === null ? undefined : this.applicationStateService.chosenModel;
        if (this.applicationStateService.chosenModel === undefined) {
            this.applicationStateService.chosenModel = model;
            let quote = this.applicationStateService.getQuote();
            if (quote.modelId !== model.ModelId && (quote.modelId !== 0 && quote.modelId !== null)) {
                this.toast = {
                    type: 'warning',
                    title: 'Warning',
                    body: ToastrModelsComponent,
                    bodyOutputType: BodyOutputType.Component,
                    timeout: 0
                }
                this.spinner.hideSpinner();
                this.toasterService.pop(this.toast);
            } else {
                if (quote.modelId !== model.ModelId || (quote.modelId === 0 || quote.modelId === null)) {
                    this.chooseModels(model);
                } else {
                    this.spinner.showSpinner();
                    this.applicationStateService.chosenModel = undefined;
                    this.router.navigate(['options-configuration', quote.quoteId]);
                }
            }
        }
    }

    chooseModels(model: Model) {
        this.spinner.showSpinner();
        this.closeModelInformation();
        this.applicationStateService.chosenModel = undefined;
        this.quoteInfoService.creatingBaseOptions$.next(true);

        let quote = new Quote();
        this.quoteInfoService.modelId$.next(model.ModelId);
        this.applicationStateService.setModel(model)
            .subscribe(response => {
                this.toasterService.clear();
                quote = response;
                this.applicationStateService.setQuote(response);

                this.optionsAdminService.getOptionsAdminCategories(quote.plantId, quote.modelId).subscribe(categories => {
                    if (categories.length > 0) {
                        this.applicationStateService.setCategoryId(categories[0].WebCategoryId);
                    }
                    this.quoteInfoService.creatingBaseOptions$.next(true);
                    this.modelService.setBaseOptionsForModel(quote.quoteId, Number(quote.retailerNumber))
                        .subscribe(baseOptions => {
                            this.quoteInfoService.creatingBaseOptions$.next(false);
                            this.router.navigate(['options-configuration', quote.quoteId]);
                        });
                });
            });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/information-aside-models.service.ts